import { loadCookieData, saveCookieData } from '@densityco/lib-common-auth';

export function initializeImpersonationCookie() {
  const cookie = loadCookieData();

  // Other apps share this preferences cookie and may omit impersonation.
  // Restore the auth library's disabled default before its components render,
  // preserving the environment and all other existing preferences.
  if (cookie.impersonate == null) {
    saveCookieData({ ...cookie, impersonate: { enabled: false } });
  }
}
